import { Helpers } from '../../helpers';
import { IScheduleActivity } from '../../interfaces/ischedule-activity';
import { Calendar } from '../calendar';
import { DrillGroup } from '../drill-group';
import { Equation } from '../equation';
import { FracFleet } from '../frac-fleet';
import { FracGroup } from '../frac-group';
import { PhaseStepType } from '../phase-step-type';
import { ProjectCostCodeCostTypeItemsRevision } from '../project-cost-code-cost-type-items-revision';
import { ProjectResourceItemsRevision } from '../project-resource-items-revision';
import { Rig } from '../rig';
import { Schedule } from '../schedule';
import { ScheduleActivityCostCodeCostType } from '../schedule-activity-cost-code-cost-type';
import { ScheduleActivityMajorMilestone } from '../schedule-activity-major-milestone';
import { ScheduleActivityResourceCategory } from '../schedule-activity-resource-category';
import { ScheduleActivityStatus } from '../schedule-activity-status';
import { ScheduleConstraintType } from '../schedule-constraint-type';
import { Well } from '../well';

export class ScheduleActivityBase {
  ScheduleActivityId: number;
  ScheduleId: number;
  ScheduleActivityStatusCode: string;
  PlannedDuration: number;
  IdleDuration: number | null;
  ActiveDuration: number;
  RemainingDuration: number;
  PhysicalPercentComplete: number;
  ActualStartDate: Date | null;
  ActualFinishDate: Date | null;
  PrimaryConstraintType: string;
  PrimaryConstraintDate: Date | null;
  WellId: number | null;
  DrillGroupId: number | null;
  FracGroupId: number | null;
  ProductionGroupId: number | null;
  PlannedStartDate: Date | null;
  PlannedEndDate: Date | null;
  Name: string | null;
  DurationEquationsId: number | null;
  IsCalculatedDuration: boolean;
  DurationOverride: number | null;
  RigId: number | null;
  VariableName: string | null;
  ExecutionError: string | null;
  FormulaMissingVariables: string | null;
  IsSummary: boolean | null;
  SortOrder: number | null;
  Cost: number | null;
  CalendarId: number | null;
  Phase: string | null;
  Step: string | null;
  FracFleetId: number | null;
  IsProjectLevel: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  PhaseStepTypeId: number | null;
  SysStartTime: Date;
  SysEndTime: Date;

  ProjectCostCodeCostTypeItemsRevisions_ScheduleActivity?: Array<ProjectCostCodeCostTypeItemsRevision> | null;
  ProjectResourceItemsRevisions_ScheduleActivity?: Array<ProjectResourceItemsRevision> | null;
  ScheduleActivityCostCodeCostTypes_ScheduleActivity?: Array<ScheduleActivityCostCodeCostType> | null;
  ScheduleActivityMajorMilestones_ScheduleActivity?: Array<ScheduleActivityMajorMilestone> | null;
  ScheduleActivityResourceCategories_ScheduleActivity?: Array<ScheduleActivityResourceCategory> | null;
  Calendar?: Calendar;
  DrillGroup?: DrillGroup;
  FracFleet?: FracFleet;
  FracGroup?: FracGroup;
  PhaseStepType?: PhaseStepType;
  Rig?: Rig;
  ScheduleActivityStatus?: ScheduleActivityStatus;
  Schedule?: Schedule;
  Well?: Well;
  Equation?: Equation;
  ScheduleConstraintType?: ScheduleConstraintType;

  constructor(item?: IScheduleActivity) {
    if (item) {

      this.ScheduleActivityId = item.ScheduleActivityId;
      this.ScheduleId = item.ScheduleId;
      this.ScheduleActivityStatusCode = item.ScheduleActivityStatusCode;
      this.PlannedDuration = item.PlannedDuration;
      this.IdleDuration = item.IdleDuration;
      this.ActiveDuration = item.ActiveDuration;
      this.RemainingDuration = item.RemainingDuration;
      this.PhysicalPercentComplete = item.PhysicalPercentComplete;
      this.ActualStartDate = item.ActualStartDate ? new Date(item.ActualStartDate) : null;
      this.ActualFinishDate = item.ActualFinishDate ? new Date(item.ActualFinishDate) : null;
      this.PrimaryConstraintType = item.PrimaryConstraintType;
      this.PrimaryConstraintDate = item.PrimaryConstraintDate ? new Date(item.PrimaryConstraintDate) : null;
      this.WellId = item.WellId;
      this.DrillGroupId = item.DrillGroupId;
      this.FracGroupId = item.FracGroupId;
      this.ProductionGroupId = item.ProductionGroupId;
      this.PlannedStartDate = item.PlannedStartDate ? new Date(item.PlannedStartDate) : null;
      this.PlannedEndDate = item.PlannedEndDate ? new Date(item.PlannedEndDate) : null;
      this.Name = item.Name;
      this.DurationEquationsId = item.DurationEquationsId;
      this.IsCalculatedDuration = item.IsCalculatedDuration;
      this.DurationOverride = item.DurationOverride;
      this.RigId = item.RigId;
      this.VariableName = item.VariableName;
      this.ExecutionError = item.ExecutionError;
      this.FormulaMissingVariables = item.FormulaMissingVariables;
      this.IsSummary = item.IsSummary;
      this.SortOrder = item.SortOrder;
      this.Cost = item.Cost;
      this.CalendarId = item.CalendarId;
      this.Phase = item.Phase;
      this.Step = item.Step;
      this.FracFleetId = item.FracFleetId;
      this.IsProjectLevel = item.IsProjectLevel;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.PhaseStepTypeId = item.PhaseStepTypeId;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;

      this.ProjectCostCodeCostTypeItemsRevisions_ScheduleActivity = Helpers.createClassArray(ProjectCostCodeCostTypeItemsRevision, item.ProjectCostCodeCostTypeItemsRevisions_ScheduleActivity);
      this.ProjectResourceItemsRevisions_ScheduleActivity = Helpers.createClassArray(ProjectResourceItemsRevision, item.ProjectResourceItemsRevisions_ScheduleActivity);
      this.ScheduleActivityCostCodeCostTypes_ScheduleActivity = Helpers.createClassArray(ScheduleActivityCostCodeCostType, item.ScheduleActivityCostCodeCostTypes_ScheduleActivity);
      this.ScheduleActivityMajorMilestones_ScheduleActivity = Helpers.createClassArray(ScheduleActivityMajorMilestone, item.ScheduleActivityMajorMilestones_ScheduleActivity);
      this.ScheduleActivityResourceCategories_ScheduleActivity = Helpers.createClassArray(ScheduleActivityResourceCategory, item.ScheduleActivityResourceCategories_ScheduleActivity);
      this.Calendar = new Calendar(item.Calendar);
      this.DrillGroup = new DrillGroup(item.DrillGroup);
      this.FracFleet = new FracFleet(item.FracFleet);
      this.FracGroup = new FracGroup(item.FracGroup);
      this.PhaseStepType = new PhaseStepType(item.PhaseStepType);
      this.Rig = new Rig(item.Rig);
      this.ScheduleActivityStatus = new ScheduleActivityStatus(item.ScheduleActivityStatus);
      this.Schedule = new Schedule(item.Schedule);
      this.Well = new Well(item.Well);
      this.Equation = new Equation(item.Equation);
      this.ScheduleConstraintType = new ScheduleConstraintType(item.ScheduleConstraintType);
    }
  }
}